var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMic = function SvgMic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.523c1.453 0 2.414-1.085 2.414-2.625V6.961c0-1.54-.96-2.625-2.414-2.625-1.453 0-2.422 1.086-2.422 2.625v4.937c0 1.54.969 2.625 2.422 2.625Zm-5.164-2.46c0 2.828 1.883 4.828 4.68 5.03v1.9H8.703a.48.48 0 1 0 0 .96h6.594a.48.48 0 1 0 0-.96h-2.82v-1.9c2.804-.202 4.687-2.202 4.687-5.03v-1.461a.482.482 0 0 0-.484-.485.482.482 0 0 0-.485.485v1.43c0 2.491-1.648 4.179-4.195 4.179-2.547 0-4.203-1.688-4.203-4.18v-1.43a.475.475 0 0 0-.477-.484.482.482 0 0 0-.484.485v1.46Z"
  })));
};
export default SvgMic;